import { useEffect } from 'react';
// routes
import Router from './routes';
// attribution
import { captureAttribution } from './utils/attribution';
// theme
import ThemeProvider from './theme';
// hooks
import useDarkMode from './hooks/useDarkMode';
import { DarkModeContext } from './context/DarkModeContext';
import ToastProvider from './context/ToastContext';
import { WsProvider } from './context/WsContext';
// components
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';

// ----------------------------------------------------------------------

export default function App() {
  const darkMode = useDarkMode();

  // Capture inbound attribution (utm_source / ref) once per session so
  // downstream events (signup, vote, re-share) can carry the original
  // referrer. Runs before routing kicks in so we read the pristine URL.
  useEffect(() => {
    captureAttribution();
  }, []);

  return (
    <DarkModeContext.Provider value={darkMode}>
      <ThemeProvider mode={darkMode.mode}>
        <ToastProvider>
          {/* Above <Router /> so the one socket survives route changes -
              mounting it any deeper reconnects on every navigation. */}
          <WsProvider>
            <ErrorBoundary>
              <ScrollToTop />
              <BaseOptionChartStyle />
              <Router />
            </ErrorBoundary>
          </WsProvider>
        </ToastProvider>
      </ThemeProvider>
    </DarkModeContext.Provider>
  );
}
